import { CPLApiException } from "services/api/cplapi/CPLAPI";
import { SubmissionLockError } from "services/DataImportService";

// Lock takeovers carry the holder's name in the error message; 509 rejections carry the reason
// in the body — either a bare string or `{ message }`. Anything else (network, 500) falls back.
export function writeErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof SubmissionLockError) {
    return error.message;
  }
  if (!(error instanceof CPLApiException) || error.status !== 509 || !error.response) {
    return fallback;
  }
  try {
    const parsed = JSON.parse(error.response);
    return typeof parsed === "string" ? parsed : parsed?.message ?? fallback;
  } catch {
    return error.response;
  }
}
